import React from 'react';
import {
    Button,
    DialogTitle,
    Flex,
    HTMLDialog,
    Icon,
    PriorityIcon,
    noop
} from '@priority-software/priority-style-react';
import cx from 'classnames';
import styles from './styles.module.scss';
import text from './texts';
import {localText} from './texts';
import {useEventListener} from 'usehooks-ts';
import {keys} from '../../constants/KeyCodes';

type Props = {
    componentClasses?: string;
    isOpen: boolean;
    onClose?: () => void;
    isCopyAction: boolean;
    action: () => void;
};

export const HelpDialogF9 = ({componentClasses, isOpen, onClose, isCopyAction, action}: Props) => {
    const handler = e => {
        e.stopPropagation();
        if (e.key === keys.ESC) {
            onClose();
        }
    };
    useEventListener('keydown', handler);
    return (
        <HTMLDialog
            componentClasses={cx(styles.wrapperHelp, componentClasses)}
            size="small"
            isOpen={isOpen}
            onClose={onClose}
            title={
                <>
                    <Icon
                        hoverable={false}
                        active={false}
                        iconColor="secondary-400"
                        onClick={noop}
                        icon={PriorityIcon.questionCircle}
                        componentClasses={styles.deleteIcon}
                    />
                    <DialogTitle title={text.help} />
                </>
            }
            content={isCopyAction ? text.help_text_copy : text.help_text_paste}
            footer={
                <Flex justifyContent="flex-end">
                    <Button onClick={action}>{localText.ok}</Button>
                </Flex>
            }
        />
    );
};
